import useAuthenticatedWebsocket from './useAuthenticatedWebSocket';

export default function useSendMessageRead() {
  const { sendJsonMessage } = useAuthenticatedWebsocket();

  return (deliveryToken) => {
    sendJsonMessage({
      action: 'message_read',
      body: {
        delivery_token: deliveryToken,
      },
    });
  };
}
